import styled, { css } from "styled-components";
import { system } from "styled-system";
import { Box } from "./Box";
const verticalMargin = system({
    space: {
        property: "marginTop",
        scale: "space",
    },
});
const horizontalMargin = system({
    space: {
        property: "marginLeft",
        scale: "space",
    },
});
export const Stack = styled(Box) `
  ${({ direction }) => direction === "horizontal" &&
    css `
      display: flex;
    `}

  & > * + *:not([role="tooltip"]) {
    ${({ direction }) => (direction === "vertical" ? verticalMargin : horizontalMargin)}
  }
`;
Stack.defaultProps = {
    direction: "vertical",
    space: 1,
};
